import Api from '@/lib/api/api';
import v5_Model from '@/models/v5/model';

var LogsModel = v5_Model.extend({
    initialize: function() {
        this.type = 'logs';
        this.set('logs', []);
    },
    parse: function (attrs) {
        // prevent each log from being added to the model individually
        // also reverse order for display
        attrs.data.reverse();
        this.set('logs', attrs.data);
        attrs.data = undefined;
        return attrs;
    },
    url: function () { return Api.urls.logs({ device_id: this.id }); },
    fetch_logs: function() {
        var self = this;

        var data = {
            'page[size]': 1000,
            'page[number]': 1,
        };
        /*
            *  Limit the size of a Logs Collection
            *  WEB-1370, code views are killing the
            *  browser when they get too large.
            */
        this.on('change:logs', function(){
            while ( this.get('logs') && this.get('logs').length > 1000 ) {
                this.get('logs').shift();
            }
        });

        return new Promise(function(resolve, reject) {
            self.fetch({ data: data })
                .then(
                    resolve, function(model, response) { reject(response); }
                );
        });
    },

});

export default LogsModel;


